import React, {FocusEventHandler} from "react";

interface FieldDualInputValue {
    left?: string
    right?: string
}

interface FieldDualInputProps {
    id?: string
    label?: string
    required?: boolean
    value?: FieldDualInputValue
    invalid?: boolean
    help?: string
    disabledLeft?: boolean
    disabledRight?: boolean
    inputTransform?: (value: FieldDualInputValue) => FieldDualInputValue
    onChange?: (value: FieldDualInputValue) => void
    onBlur?: FocusEventHandler<any> | undefined
}

function FieldDualInput({
                            id,
                            label,
                            required,
                            value,
                            invalid,
                            help,
                            disabledLeft,
                            disabledRight,
                            inputTransform,
                            onChange,
                            onBlur

                        }: FieldDualInputProps) {
    return <>
        <div id={id} className={`field ${required ? 'required' : ''}`}>
            {label && <label className={`label`}>{label}</label>}

            <div id={id} className={`field has-addons`} style={{margin: '0'}}>
                <div className="control is-expanded">
                    <input
                        disabled={disabledLeft}
                        className={`input is-fullwidth ${invalid ? 'is-danger' : ''} ${required ? 'required' : ''}`}
                        value={value?.left || ''}
                        onChange={e => {
                            onChange && onChange({
                                left: e.target.value || undefined,
                                right: value?.right
                            })
                        }}
                        onBlur={e => onBlur && onBlur(e)}
                        onInput={e => {
                            if (inputTransform) {
                                const input = e.currentTarget;
                                const start = input.selectionStart;
                                const end = input.selectionEnd;
                                const inputValue = input.value
                                const val = inputTransform({
                                    left: inputValue,
                                    right: value?.right
                                })
                                const valLeft = val.left
                                if (inputValue !== valLeft) {
                                    input.value = valLeft || ''
                                    setTimeout(() => {
                                        input.setSelectionRange(start, end)
                                    }, 1)
                                }
                            }
                        }}
                        type="text"
                    />
                </div>
                <div className="control">
                    <input
                        disabled={disabledRight}
                        className={`input ${invalid ? 'is-danger' : ''} ${required ? 'required' : ''}`}
                        style={{width: '4em'}}
                        value={value?.right || ''}
                        onChange={e => {
                            onChange && onChange({
                                left: value?.left,
                                right: e.target.value || undefined
                            })
                        }}
                        onBlur={e => onBlur && onBlur(e)}
                        onInput={e => {
                            if (inputTransform) {
                                const input = e.currentTarget;
                                const start = input.selectionStart;
                                const end = input.selectionEnd;
                                const inputValue = input.value
                                const val = inputTransform({
                                    left: value?.left,
                                    right: inputValue
                                })
                                const valRight = val.right
                                if (inputValue !== valRight) {
                                    input.value = valRight || ''
                                    setTimeout(() => {
                                        input.setSelectionRange(start, end)
                                    }, 1)
                                }
                            }
                        }}
                        type="text"
                    />
                </div>
            </div>
            <p className={`help ${invalid ? 'is-danger' : ''}`}>{help}</p>
        </div>
    </>
}

export {
    FieldDualInput
}
